import { EntityParams } from "app/models/entity-params";
import { LendersPositionFormParams } from "app/models/lenders-position-params";

type CSVRow = Record<string, string>;


export function transformLendersCSVToSubmission(
    csvRows: CSVRow[],
    entities: EntityParams[],
    transformValues: (values: any) => any
): { [key: string]: LendersPositionFormParams[][] } {
    const lenderAllocationsFacility: { [key: string]: [value: LendersPositionFormParams[]] } = {}
    csvRows.map((data: Record<string, string>) => {
        const entityId = entities.find(entity => entity.entityName === data['Entity Name'])?.id
        const updatedData = {
            "id": null,
            "percentage": "",
            "amount": data['Amount'] ?? 0,
            "lenderName": "",
            "lenders": {
                "id": entityId ?? "",
            },
            "creditContactId": null,
            "adminContactId": null,
            "wireInstructions": []
        }
        const transformedCsv = transformValues({ lendersPosition: [updatedData] })
        if (lenderAllocationsFacility[data['Facility ID']]) {
            lenderAllocationsFacility[data['Facility ID']].push(transformedCsv)
        } else {
            lenderAllocationsFacility[data['Facility ID']] = [transformedCsv]
        }
    })

    return lenderAllocationsFacility
}
